import React from "react";

import { Link } from "react-router-dom";
import { ReactComponent as Eye } from "../../icons/eye-bold.svg";

import { createStore } from "../../reducers/store";
import { connect } from "react-redux";

class Overlay extends React.Component {
  _handleCreate = () => {
    this.props.createStore({
      templateId: this.props.id,
      data: {
        siteName: "New Farmakom",
        siteCompanyName: "Farmakom Srl",
        siteHostname: "http://localhost",
      },
    });
  };

  render() {
    const props = this.props;
    return (
      <div className="template-overlay">
        {props.showEdit && (
          <Link className="button" to={`#`} onClick={this._handleCreate}>
            Modifica
          </Link>
        )}
        <Link className="button" to={`${props.previewUrl}/${props.id}`}>
          <Eye
            style={{
              color: "white",
              marginRight: "5px",
              width: 24,
              height: 24,
            }}
          />
          Visualizza
        </Link>
      </div>
    );
  }
}

const mapDispatchToProps = (props) => ({});

export default connect(mapDispatchToProps, { createStore })(Overlay);
